import type { ReactElement, ReactNode } from 'react';

export function Loading({ children = '載入中…' }: { readonly children?: ReactNode }): ReactElement {
  return <p className="status-message" role="status">{children}</p>;
}

export function ErrorMessage({ message }: { readonly message: string }): ReactElement {
  return <p className="error-message" role="alert">{message}</p>;
}

export function EmptyMessage({ children }: { readonly children: ReactNode }): ReactElement {
  return <p className="empty-message">{children}</p>;
}
